module.exports = __webpack_public_path__ + "media/images/icon__point--lost@3x-8858d0cf9fc758aba6cb1e535c7db189.png";